import React from 'react';

interface GradientBorderProps {
  borderRadius?: number;
  strokeWidth?: number;
  className?: string;
}

export default function GradientBorder({
  borderRadius = 32,
  strokeWidth = 1.5,
  className,
}: GradientBorderProps) {
  const offset = strokeWidth / 2;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      width="100%"
      height="100%"
    >
      <defs>
        <linearGradient id="gradient-border" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fff" />
          <stop offset="50%" stopColor="#8ea8fe" />
          <stop offset="100%" stopColor="#f899ff" />
        </linearGradient>
      </defs>
      <rect
        x={offset}
        y={offset}
        width={`calc(100% - ${strokeWidth}px)`}
        height={`calc(100% - ${strokeWidth}px)`}
        rx={borderRadius}
        ry={borderRadius}
        fill="none"
        stroke="url(#gradient-border)"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
